module.exports = __webpack_public_path__ + "api/static/media/csi_star.1eef2b59.jpeg";